import React from "react";
import ButtonComponent from "./button/Button";

export const ConfirmUploadModal = ({ file, show, onClose, onConfirm }) => {
  if (!show) {
    return null;
  }

  return (
    <div className="modal">
      <div className="modal-content">
        <h2>Confirm Submission of Forecast</h2>
        <div className="modal-body">
          <p>
            Are you sure you want to submit the{" "}
            <span className="red-text">Short-term Forecast</span>?
          </p>
          {file && <p>File selected: {file.name}</p>}
        </div>
        <div className="button-container">
          <ButtonComponent
            maxWidth="100px"
            label="Cancel"
            bgColor="grey"
            color="white"
            onClick={onClose}
          />
          <ButtonComponent
            maxWidth="100px"
            label="Ok"
            bgColor="black"
            color="white"
            onClick={onConfirm}
          />
        </div>
      </div>
    </div>
  );
};
export const UploadProgressModal = ({ progress, show, onClose }) => {
  if (!show) {
    return null;
  }

  return (
    <div className="modal">
      <div className="modal-content">
        <h2>Upload in progress</h2>
        <p>{progress}%</p>
        <div className="progress-bar">
          <div
            className="progress-bar-fill"
            style={{ width: `${progress}%` }}
          ></div>
        </div>
        <p>Select the file to upload</p>
        <button onClick={onClose}>Cancel</button>
      </div>
    </div>
  );
};
export const UploadSuccessModal = ({
  show,
  onClose,
  onConfirm,
  ButtonComponent,
}) => {
  if (!show) {
    return null;
  }

  return (
    <div className="modal">
      <div className="modal-content">
        <h2>Upload Completed</h2>
        <div className="modal-body">
          <div className="success-content">
            <span className="checkmark">✔</span>
            <p>Upload Successful</p>
          </div>
        </div>
        <div className="button-container">
          <ButtonComponent
            maxWidth="100px"
            label="Cancel"
            bgColor="grey"
            color="white"
            onClick={onClose}
          />
          <ButtonComponent
            maxWidth="100px"
            label="Ok"
            bgColor="black"
            color="white"
            onClick={onConfirm}
          />
        </div>
      </div>
    </div>
  );
};

export const UploadFailedModal = ({
  show,
  onClose,
  onConfirm,
  ButtonComponent,
}) => {
  if (!show) {
    return null;
  }

  return (
    <div className="modal">
      <div className="modal-content">
        <h2>Upload Completed</h2>
        <div className="modal-body">
          <div className="success-content">
            <span className="error-icon">⚠</span>
            <p className="red-text">Upload Failed</p>
          </div>
        </div>
        <div className="button-container">
          <ButtonComponent
            maxWidth="100px"
            label="Cancel"
            bgColor="grey"
            color="white"
            onClick={onClose}
          />
          <ButtonComponent
            maxWidth="100px"
            label="Ok"
            bgColor="black"
            color="white"
            onClick={onConfirm}
          />
        </div>
      </div>
    </div>
  );
};

export const transformData = (input) => {
  return input.flatMap((bottler) =>
    bottler.customers.flatMap((customer) =>
      customer.locationIds.map((locationId) => ({
        locationId: locationId.split('-')[0],
        customerId: customer.customerID.split('-')[0],
      }))
    )
  );
};

export const extractData = (input) => {
  const locationIds = new Set();
  const customerIds = new Set();
  const bottlers = new Set();

  input.forEach((bottler) => {
    bottlers.add(bottler.bottler);
    bottler.customers.forEach((customer) => {
      customerIds.add(customer.customerID.split('-')[0]);
      customer.locationIds.forEach((locationId) => {
        locationIds.add(locationId.split('-')[0]);
      });
    });
  });

  return [
    { locationIds: Array.from(locationIds) },
    { customerIds: Array.from(customerIds) },
    { bottlers: Array.from(bottlers) },
  ];
};